import "./Accordion/AccordionComponent"
import "./Cookie/CookieComponent";
import "./Dropdown/DropdownComponent";
import "./Form/FormComponent";
import "./Header/HeaderComponent";
import "./Modal/ModalComponent";
import "./Notification/NotificationComponent";
import "./Slider/SliderComponent";
import "./Trombinoscope/SliderTrombiComponent";
import "./Temoignage/SliderTemoignageComponent";
import "./Slider/SliderPartnerComponent";
import "./Tabs/TabsComponent";
import "./Video/VideoComponent";
import "./Manifest/ManifestComponent";



// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/includes/Components/components.js